<span (click)="onClick($event)" [matTooltip]="tooltipKey | transloco" class="inline-flex items-center line-broken-tooltip" matTooltipPosition="above" style="pointer-events: auto;">
    <mat-icon
    color="primary"
    class="icon-size-5 text-current"
    [svgIcon]="'feather:help-circle'"></mat-icon>
</span>
